module.exports = __webpack_public_path__ + "static/media/opakowania_1_A.159a856a.png";